export default __webpack_public_path__ + "static/media/arm_swing_intro.649b5e23.png";